
import { Calendar, Home, LineChart, Building2, Users, Settings, BookOpen, Shield, Target, Truck, Cloud, Target as TargetIcon } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarHeader,
} from "@/components/ui/sidebar";
import { useOrganization } from "@/hooks/useOrganization";

const menuItems = [
  { title: "Dashboard", url: "/", icon: Home, id: "dashboard-tab" },
  { title: "Data Management", url: "/data-management", icon: BookOpen, id: "data-management-tab" },
  { title: "ESG Reporting", url: "/reporting", icon: LineChart, id: "esg-reporting-tab" },
  { title: "Risk Management", url: "/risk-management", icon: Shield, id: "risk-management-tab" },
  { title: "Carbon Accounting", url: "/carbon-accounting", icon: Calendar, id: "carbon-accounting-tab" },
  { title: "Portfolio ESG", url: "/portfolio", icon: Building2, id: "portfolio-tab" },
  { title: "Net Zero Planning", url: "/net-zero", icon: Target, id: "net-zero-tab" },
  { title: "Supply Chain", url: "/supply-chain", icon: Truck, id: "supply-chain-tab" },
  { title: "Materiality Assessment", url: "/materiality-assessment", icon: TargetIcon, id: "materiality-assessment-tab" },
  { title: "Climate Risk Assessment", url: "/climate-risk", icon: Cloud, id: "climate-risk-tab" },
  { title: "Settings", url: "/settings", icon: Settings, id: "settings-tab" },
];

export function AppSidebar() {
  const location = useLocation();

  const { organizationId, organizationName, isOrganization, isTeamMember, loading } = useOrganization();
console.log(222,organizationName)
console.log(2442,organizationId)
  return (
    <Sidebar id="main-sidebar">
      <SidebarHeader className="border-b mt-2 px-6 py-2 space-y-0.5">
        <h2 className="text-lg font-semibold leading-none">
          ESG Platform
        </h2>
        <span className="text-xs leading-none">
          {organizationName || ''}
        </span>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton 
                    asChild 
                    isActive={location.pathname === item.url}
                    id={item.id}
                  >
                    <Link to={item.url}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
